module.exports = __webpack_public_path__ + "img/turbo-features5.947e9903.png";